import { FC } from 'react';
import classNames from 'classnames';
import SvgRevert from '@app/shared/icons/Revert';
import { CaseDto } from '@app/shared/models/contracts/project-dto';
import styles from './discount-rate-override.module.scss';
import { OverrideField } from './useDiscountRateOverride';
import OverrideCells from './OverrideCells';
import { CaseStructureItem, fieldHasAnyOverrides } from './discountRateOverrideUtils';

interface CategoryRowsProps {
  instrumentId: string;
  field: OverrideField;
  label: string;
  trancheId?: Nullable<string>;
  trancheIndex?: number;
  indented?: boolean;
  initializedCases: CaseDto[];
  casesStructure: CaseStructureItem[];
  findSortedCaseIndex: (caseId: string) => number;
  handleRevertCategory: (
    instrumentId: string,
    field: OverrideField,
    trancheId?: Nullable<string>
  ) => void;
}

const DiscountRateOverrideCategoryRows: FC<CategoryRowsProps> = ({
  instrumentId,
  field,
  label,
  trancheId,
  trancheIndex,
  indented = false,
  initializedCases,
  casesStructure,
  findSortedCaseIndex,
  handleRevertCategory,
}) => {
  const cellsProps = {
    casesStructure,
    findSortedCaseIndex,
    initializedCases,
    instrumentId,
    field,
  };

  const isOverridden = fieldHasAnyOverrides(initializedCases, instrumentId, field, trancheId);

  const testId =
    trancheIndex !== undefined
      ? `${field}-tranche-row-${instrumentId}-${trancheIndex}`
      : `${field}-row-${instrumentId}`;
  const revertTestId =
    trancheIndex !== undefined
      ? `revert-${field}-${instrumentId}-tranche-${trancheIndex}`
      : `revert-${field}-${instrumentId}`;
  const keyPrefix = trancheIndex !== undefined ? `${field}-${trancheIndex}` : field;

  return (
    <tr data-testid={testId}>
      <td
        className={classNames('table-primary__cell--vertical-separator', {
          'table-primary__cell--indentation': indented,
        })}>
        <span>{label}</span>
        {isOverridden && (
          <SvgRevert
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => handleRevertCategory(instrumentId, field, trancheId)}
            className={styles['revert-button']}
            data-testid={revertTestId}
          />
        )}
      </td>
      <OverrideCells trancheId={trancheId ?? null} keyPrefix={keyPrefix} {...cellsProps} />
    </tr>
  );
};

export default DiscountRateOverrideCategoryRows;
